// Label-source display helpers.
// - `label_gemini_translated`: Gemini translated an ingredient list printed
//   only in a non-Latin script into INCI names.
// - `gemini_memory`: no source had the list, so the AI gave it from what it
//   knows (no web source). The product stays private to its owner until our
//   team confirms it; the owner can confirm it with a photo of the label.

export const TRANSLATED_LABEL_NOTE =
  'Ingredients translated automatically from the label — may be inexact, our team will review them';

/** Compact marker for list items (History, Favorites). */
export const TRANSLATED_LABEL_MARKER = 'Translated';

export const UNVERIFIED_LIST_NOTE =
  'Ingredients not confirmed: the AI gave this list without a source, so it may differ from your pack. Photograph the ingredient list to confirm it. Our team will also review it.';

/** Compact marker for list items (History, Favorites). */
export const UNVERIFIED_LIST_MARKER = 'Not confirmed';

export function isTranslatedLabel(source: string | null | undefined): boolean {
  return source === 'label_gemini_translated';
}

export function isUnverifiedList(source: string | null | undefined): boolean {
  return source === 'gemini_memory';
}

/** The note a product page shows for its list source, or null. */
export function labelSourceNote(source: string | null | undefined): string | null {
  if (isUnverifiedList(source)) return UNVERIFIED_LIST_NOTE;
  if (isTranslatedLabel(source)) return TRANSLATED_LABEL_NOTE;
  return null;
}

/** The compact marker a list item shows for its list source, or null. */
export function labelSourceMarker(source: string | null | undefined): string | null {
  if (isUnverifiedList(source)) return UNVERIFIED_LIST_MARKER;
  if (isTranslatedLabel(source)) return TRANSLATED_LABEL_MARKER;
  return null;
}
